var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactionAnimation pointer-events-none"},[_c('canvas',{ref:"animationCanvas",attrs:{"width":_vm.CANVAS_SIZE.width,"height":_vm.CANVAS_SIZE.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }